module.exports = new __parcel__URL__("deer.3662e324.svg").toString();